/* Menyunun görünüş ayarları — rəng çaları, fon naxışı və menyunun
   quruluşu. Ayarlar serverə yazılmır: bu, istifadəçinin öz brauzerinin
   seçimidir, hər kompüterdə ayrıca saxlanılır.

   Ayarı həm yan panel, həm də "Menyu quraşdırması" səhifəsi oxuyur.
   Səhifə ayarı dəyişəndə yan panel dərhal xəbər tutsun deyə pəncərə
   hadisəsi göndərilir — əks halda dəyişiklik yalnız səhifə yenilənəndə
   görünərdi. */

export const MENYU_HADISE = 'ems-menyu-ayari';

export const MENYU_ACARLAR = {
  tema:    'ems_yan_tema',
  naxis:   'ems_yan_naxis',
  gorunus: 'ems_menyu_gorunus',
};

export function ayarOxu(acar, defolt) {
  try {
    const v = localStorage.getItem(acar);
    return v === null ? defolt : v;
  } catch { return defolt; }
}

export function ayarYaz(acar, deyer) {
  try { localStorage.setItem(acar, deyer); } catch { /* gizli rejim */ }
  window.dispatchEvent(new CustomEvent(MENYU_HADISE, { detail: { acar, deyer } }));
}
